module.exports = __webpack_public_path__ + "5f2db23585f8bf9014f27ffa0eec205e.png";


//////////////////
// WEBPACK FOOTER
// ./app/stylesheets/header/images/search-icon.png
// module id = 1100
// module chunks = 4